import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Container, Col, Form, Row, Image, Button } from "react-bootstrap";
import Switch from "react-switch";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Alert from "react-s-alert";

import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert } from "../../../../function/alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  change_table_status_table_management,
  vendor_add_diner_reservation,
  get_diner_reservation,
  get_pending_diner,
  get_reservation_diner,
  vendor_get_timing_slots_reservation,
  vendor_get_available_table_action,
  vendor_dashboard_edit_action,
} from "../../../../store/actions/dashboardAction/addingAction";
import Media from "react-media";
import isEmpty from "../../../../store/validation/is-Empty";
import { ReusableOnboardingMapButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { GET_AVAILABLE_TABLE_DATA } from "../../../../store/types";
import store from "../../../../store/store";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// const validationSchema = yup.object({
//   mobile_number: yup
//     .string()
//     .required("Phone number is required")
//     .matches(phoneRegExp, "Phone number is not valid")
//     .min(10, "to short")
//     .max(10, "to long"),
//   name: yup
//     .string()
//     .required("Diner name is required")
//     .min(1, "Minimum 1 Character")
//     .max(64, "Maximum 64 Character"),
//   occasion: yup
//     .string()
//     .required("occasion is required")
//     .min(1, "Minimum 1 Character")
//     .max(512, "Maximum 512 Character"),
//   //   start_date: yup.string().required("Start date is required"),
// });

const AddDinerReservationScreen = (props) => {
  const classes = useStyles();
  const history = useHistory();

  const validate = (values) => {
    const errors = {};
    if (selectedPage === "RESERVATION") {
      if (!values.start_date) {
        errors.start_date = "Reservation Date is required";
      }
      if (!values.time) {
        errors.time = "Please select time";
      }
    }
    return errors;
  };
  const onPageChange = (value) => (e) => {
    if (value === "RESERVATION") {
      store.dispatch({ type: GET_AVAILABLE_TABLE_DATA, payload: [] });
    }
    setSelectedPage(value);
    formik.setFieldValue("kids", 0);
    formik.setFieldValue("adult", 1);
    formik.setFieldValue("handicap", 0);
    formik.setFieldValue("highchair", 0);
    formik.setFieldValue("room_number", "");
    formik.setFieldValue("table_number", "");
    formik.setFieldValue("occasion", "");
    formik.setFieldTouched("occasion", false, false);
    formik.setFieldValue("seating_preference", "");
    formik.setFieldValue("start_date", "");
    formik.setFieldValue("time", "");
  };

  const walkinData = useSelector((state) => {
    return !isEmpty(
      state.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.seating?.walkin_waitlist?.value
    )
      ? state.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.seating?.walkin_waitlist?.value
      : "";
  });
  const reservationData = useSelector((state) => {
    return !isEmpty(state.onboarding) ? state.onboarding.restaurantDetails : "";
  });

  //   const [allDinerDetails, setAllDinerDetails] = useState([]);
  const [highchairHandicappedDisable, setHighchairHandicappedDisable] =
    useState(false);

  const onChangeAccessibility = () => {
    setHighchairHandicappedDisable(!highchairHandicappedDisable);
  };

  const [onBoardingHighChair, setOnBoardingHighChair] = useState(false);
  const [onBoardingHandicap, setOnBoardingHandicap] = useState(false);
  const [onBoardingTableNumber, setOnBoardingTableNumber] = useState(false);
  const [onBoardingRoomNumber, setOnBoardingRoomNumber] = useState(false);
  const [onBoardingKids, setOnBoardingKids] = useState(false);
  const [autoAcceptPaxLimit, setAutoAcceptPaxLimit] = useState(false);
  const [allSeatingArea, setAllSeatingArea] = useState([]);
  const [reservationTimeSlots, setReservationTimeSlots] = useState([]);
  const [availableTableData, setAvailableTableData] = useState([]);
  const [minimumPeople, setMinimumPeople] = useState(0);
  const [maximumPeople, setMaximumPeople] = useState(0);
  const [subcriptionTableNumber, setSubcriptionTableNumber] = useState([]);

  const dinerInfo = props?.history?.location?.state?.dinerInfo;

  const [selectedPage, setSelectedPage] = useState(
    dinerInfo?.service_type || "SEATING"
  );

  const formik = useFormik({
    initialValues: {
      id: "",
      vendor_id: "",
      code: dinerInfo?.user_details?.country_code || "",
      kids: dinerInfo?.kids_count || 0,
      adult: dinerInfo?.adult_count || 1,
      handicap: dinerInfo?.handicap_chair || 0,
      highchair: dinerInfo?.high_chair || 0,
      room_number: dinerInfo?.room_number || "",
      table_number: dinerInfo?.table_number || "",
      occasion: dinerInfo?.occasion || "",
      seating_preference: dinerInfo?.seating_preference[0] || "",
      service_type: dinerInfo?.service_type || "",
      pointOfEntry: dinerInfo?.pointOfEntry || "",
      mobile_number: dinerInfo?.user_details?.mobile_number || "",
      dinerName: dinerInfo?.user_details?.name || "",
      user_details: {
        country_code: dinerInfo?.user_details?.country_code || "",
        mobile_number: dinerInfo?.user_details?.mobile_number || "",
        dinerName: dinerInfo?.user_details?.name || "",
      },
      wait_time: dinerInfo?.wait_time || "",
      start_date: dinerInfo?.reservationTime
        ? moment(new Date(dinerInfo?.reservationTime)).format("YYYY-MM-DD")
        : "",
      time: dinerInfo?.reservationTime
        ? moment(new Date(dinerInfo?.reservationTime)).format("H:mm A")
        : "",
      reservationTime: "",
      error: "",
    },
    // validationSchema,
    validationSchema: yup.object({
      mobile_number: yup
        .string()
        .required("Phone number is required")
        .matches(phoneRegExp, "Phone number is not valid")
        .min(10, "to short")
        .max(10, "to long"),
      dinerName: yup
        .string()
        .required("Diner name is required")
        .min(1, "Minimum 1 Character")
        .max(64, "Maximum 64 Character"),
      occasion: yup
        .string()
        // .required("occasion is required")
        .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      // start_date: yup.string().required("Start date is required"),
    }),
    validate,

    onSubmit: (values) => {
      let token = props.auth.user.accessToken;
      let vendorId = props.auth.user.VendorUser._id;
      let subscriptionId = props.subscriptionDetails._id;

      let date = moment(formik.values.start_date).format("DD-MM-YYYY");
      let todayDate = moment().format("DD-MM-YYYY");
      let time = formik.values.time;
      let dateTime = moment(date + " " + time, "DD-MM-YYYY hh:mm A").format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let timestamp = moment(dateTime).format("x");

      var formData = {};
      formData.id = props.auth.user.VendorUser._id;
      formData.vendor_id = props.auth.user.VendorUser._id;
      formData.kids_count = values.kids;
      formData.adult_count = values.adult;
      formData.handicap_chair = values.handicap;
      formData.high_chair = values.highchair;
      formData.room_number = values.room_number.toString();
      formData.table_number = values.table_number.toString();
      formData.occasion = values.occasion;
      formData.seating_preference = formik.values.seating_preference;
      //   formData.wait_time = parseInt(state.wait_time.split("-")[1]);
      if (selectedPage === "RESERVATION") {
        formData.reservationTime = timestamp;
      }
      formData.service_type =
        selectedPage === "SEATING"
          ? "SEATING"
          : selectedPage === "RESERVATION"
          ? "RESERVATION"
          : "";
      formData.pointOfEntry = "VENDOR";
      formData.user_details = {
        country_code: values.code,
        mobile_number: values.mobile_number.toString(),
        name: values.dinerName,
      };
      if (values.adult <= 0) {
        formik.setFieldValue("error", "Add atleast one adult");
      } else {
        if (dinerInfo) {
          // Edit API call
          if (values.table_number.toString() !== dinerInfo?.table_number) {
            dinerInfo.table_number.split(",").map((table) => {
              props.change_table_status_table_management(
                subscriptionId,
                table,
                "AVAILABLE",
                token,
                vendorId
              );
            });
            props.change_table_status_table_management(
              subscriptionId,
              values.table_number.toString(),
              "ON_HOLD",
              token,
              vendorId
            );
          }
          props.vendor_dashboard_edit_action(
            formData,
            dinerInfo?._id,
            token,
            onCallBackFunc
          );
        } else {
          // Add API call
          if (selectedPage === "SEATING" || date === todayDate) {
            props.change_table_status_table_management(
              subscriptionId,
              values.table_number.toString(),
              "ON_HOLD",
              token,
              vendorId
            );
          }
          props.vendor_add_diner_reservation(
            formData,
            selectedPage === "SEATING"
              ? "Diner"
              : selectedPage === "RESERVATION"
              ? "Reservation"
              : "",
            onCallBackFunc
          );
        }
      }
    },
  });

  const [userData, setUserData] = useState("");
  const handleNumber = async () => {
    let params = {
      mobile_number:
        formik.values?.mobile_number ||
        formik.values?.user_details?.mobile_number,
      country_code:
        formik.values?.code || formik.values?.user_details?.country_code,
    };
    let mobiReg = /^[6-9]\d{9}$/;
    if (mobiReg.test(params.mobile_number)) {
      let userRes = await amApi.get("/user-check", { params: params });
      if (userRes.status === 200 && !isEmpty(userRes.data)) {
        setUserData(userRes.data);
        formik.setFieldValue(
          "dinerName",
          userRes.data?.first_name + " " + userRes.data?.last_name
        );
      } else {
        setUserData({ mobile_number: params.mobile_number });
        formik.setFieldValue("dinerName", "");
      }
    } else {
      errorAlert("Invalid Mobile Number");
    }
  };

  useEffect(() => {
    if (dinerInfo) {
      setTimeout(() => {
        formik.setFieldValue("dinerName", dinerInfo?.user_details?.name);
        formik.setFieldValue(
          "mobile_number",
          dinerInfo?.user_details?.mobile_number
        );
      }, 2000);
    }
  }, [dinerInfo]);

  // useEffect(() => {
  //   if (userData) {
  //     setTimeout(() => {
  //       formik.setFieldValue(
  //         "dinerName",
  //         userData?.first_name + " " + userData?.last_name
  //       );
  //     }, 2000);
  //   }
  // }, [userData]);
  //
  const onCallBackFunc = (e) => {
    history.push("/seatingdashboard");
  };

  const [minDate, setMinDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
  };

  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (props?.auth?.user?.VendorUser?._id) {
      if (props.auth.user.VendorUser.country_code) {
        formik.setFieldValue("code", props.auth.user.VendorUser.country_code);
      }
      formik.setFieldValue("mobile_number", "");
      formik.setFieldValue("dinerName", "");
      if (selectedPage === "SEATING") {
        let startDate = moment(new Date()).format("YYYY-MM-DD");
        let finalStartDate = startDate + " " + "00:00";
        let endDate = moment(new Date()).format("YYYY-MM-DD");
        let finalendDate = endDate + " " + "23:59";
        props.vendor_get_available_table_action(
          props.auth.user.VendorUser._id,
          finalStartDate,
          finalendDate,
          props.auth.user.accessToken
        );
      }
    }
  }, [props.auth.user]);

  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.mobile_number) {
      let mobileNumberElement = document.getElementById("mobile_number");
      mobileNumberElement.focus();
    } else if (formik.errors && formik.errors.dinerName) {
      let nameElement = document.getElementById("dinerName");
      nameElement.focus();
    } else if (formik.errors && formik.errors.occasion) {
      let occasionElement = document.getElementById("occasion");
      occasionElement.focus();
    }
  }, [count]);

  useEffect(() => {
    if (props.subscriptionDetails) {
      if (props.subscriptionDetails.casual_dining) {
        const seating = props.allSeatingAreas?.filter((seat) =>
          props.subscriptionDetails.casual_dining_status?.seating?.general_seating?.seating_areas.includes(
            seat._id
          )
        );
        const generalHighChair =
          props.subscriptionDetails.casual_dining_status?.seating
            ?.general_seating?.highchair;
        const generalHandicapped =
          props.subscriptionDetails.casual_dining_status?.seating
            ?.general_seating?.handicap;
        const generalRoomNumber =
          props.subscriptionDetails.casual_dining_status?.seating
            ?.general_seating?.seating_on_request;
        const generalTableNumber =
          props.subscriptionDetails.casual_dining_status?.seating
            ?.general_seating?.seat_management?.value;
        const generalKids =
          props.subscriptionDetails.casual_dining_status?.seating
            ?.general_seating?.kids_allowed?.value;
        const autoAcceptPaxLimit =
          props.subscriptionDetails.casual_dining_status?.seating
            ?.general_seating?.auto_pax;
        const minPeopleDiner =
          selectedPage === "SEATING"
            ? props.subscriptionDetails.casual_dining_status?.seating
                ?.walkin_waitlist?.min_person
            : props.subscriptionDetails.casual_dining_status?.seating
                ?.reservation?.minimum_person;
        const maxPeopleDiner =
          selectedPage === "SEATING"
            ? props.subscriptionDetails.casual_dining_status?.seating
                ?.walkin_waitlist?.auto_accept?.min_person
            : props.subscriptionDetails.casual_dining_status?.seating
                ?.reservation?.auto_accept?.min_person;
        const totalNumberSeatsAvailable =
          props.subscriptionDetails?.casual_dining_status?.seating?.table_management?.table_setup?.table.filter(
            (tableStatus) => tableStatus.status === "AVAILABLE"
          );

        // setHighchairHandicappedDisable(
        //   props.subscriptionDetails?.casual_dining_status?.seating
        //     ?.general_seating?.highchair &&
        //     props.subscriptionDetails?.casual_dining_status?.seating
        //       ?.general_seating?.handicap
        //     ? true
        //     : false
        // );

        setOnBoardingHighChair(generalHighChair);
        setOnBoardingHandicap(generalHandicapped);
        setOnBoardingTableNumber(generalTableNumber);
        setOnBoardingRoomNumber(generalRoomNumber);
        setOnBoardingKids(generalKids);
        setAutoAcceptPaxLimit(autoAcceptPaxLimit);
        setAllSeatingArea(seating);
        setMinimumPeople(minPeopleDiner);
        setMaximumPeople(maxPeopleDiner);
        setSubcriptionTableNumber(totalNumberSeatsAvailable);
      } else if (props.subscriptionDetails.multi_service_business) {
        const seating = props.allSeatingAreas?.filter((seat) =>
          props.subscriptionDetails.multi_service_business_status?.seating?.general_seating?.seating_areas.includes(
            seat._id
          )
        );
        const generalHighChair =
          props.subscriptionDetails.multi_service_business_status?.seating
            ?.general_seating?.highchair;
        const generalHandicapped =
          props.subscriptionDetails.multi_service_business_status?.seating
            ?.general_seating?.handicap;
        const generalRoomNumber =
          props.subscriptionDetails.multi_service_business_status?.seating
            ?.general_seating?.seating_on_request;
        const generalTableNumber =
          props.subscriptionDetails.multi_service_business_status?.seating
            ?.general_seating?.seat_management?.value;
        const generalKids =
          props.subscriptionDetails.multi_service_business_status?.seating
            ?.general_seating?.kids_allowed?.value;
        const autoAcceptPaxLimit =
          props.subscriptionDetails.multi_service_business_status?.seating
            ?.general_seating?.auto_pax;
        const minPeopleDiner =
          selectedPage === "SEATING"
            ? props.subscriptionDetails.multi_service_business_status?.seating
                ?.walkin_waitlist?.min_person
            : props.subscriptionDetails.multi_service_business_status?.seating
                ?.reservation?.minimum_person;
        const maxPeopleDiner =
          selectedPage === "SEATING"
            ? props.subscriptionDetails.multi_service_business_status?.seating
                ?.walkin_waitlist?.auto_accept?.min_person
            : props.subscriptionDetails.multi_service_business_status?.seating
                ?.reservation?.auto_accept?.min_person;
        const totalNumberSeatsAvailable =
          props.subscriptionDetails?.multi_service_business_status?.seating?.table_management?.table_setup?.table.filter(
            (tableStatus) => tableStatus.status === "AVAILABLE"
          );
        // setHighchairHandicappedDisable(
        //   props.subscriptionDetails?.multi_service_business_status?.seating
        //     ?.general_seating?.highchair &&
        //     props.subscriptionDetails?.multi_service_business_status?.seating
        //       ?.general_seating?.handicap
        //     ? true
        //     : false
        // );
        setOnBoardingHighChair(generalHighChair);
        setOnBoardingHandicap(generalHandicapped);
        setOnBoardingTableNumber(generalTableNumber);
        setOnBoardingRoomNumber(generalRoomNumber);
        setOnBoardingKids(generalKids);
        setAutoAcceptPaxLimit(autoAcceptPaxLimit);
        setAllSeatingArea(seating);
        setMinimumPeople(minPeopleDiner);
        setMaximumPeople(maxPeopleDiner);
        setSubcriptionTableNumber(totalNumberSeatsAvailable);
      }
    }
  }, [props.subscriptionDetails, props.allSeatingAreas]);

  /*******************************************
   * @DESC RESERVATION TIME SLOTS START
   *******************************************/
  useEffect(() => {
    if (
      formik.values.start_date &&
      props?.onboarding?._id &&
      props?.auth?.user?.VendorUser?._id
    ) {
      const newDate = moment(formik.values.start_date).valueOf();
      const min_lead_time = props.onboarding.minimum_lead_time;
      props.vendor_get_timing_slots_reservation(
        props.onboarding._id,
        newDate,
        props.auth.user.accessToken,
        min_lead_time
      );
      let finalStartDate = formik.values.start_date + " " + "00:00";
      let endDate = formik.values.start_date + " " + "23:59";
      props.vendor_get_available_table_action(
        props.auth.user.VendorUser._id,
        finalStartDate,
        endDate,
        props.auth.user.accessToken
      );
    }
  }, [
    formik.values.start_date,
    props?.onboarding,
    props?.auth?.user?.VendorUser,
  ]);
  /***************************/
  useEffect(() => {
    if (props.getReservationTimeSlots !== reservationTimeSlots) {
      setReservationTimeSlots(props.getReservationTimeSlots);
    }
  }, [props.getReservationTimeSlots]);

  useEffect(() => {
    if (props.getAvailableTableData !== availableTableData) {
      setAvailableTableData(props.getAvailableTableData);
    }
  }, [props.getAvailableTableData]);

  useEffect(() => {
    if (selectedPage === "SEATING") {
      let startDate = moment(new Date()).format("YYYY-MM-DD");
      let finalStartDate = startDate + " " + "00:00";
      let endDate = moment(new Date()).format("YYYY-MM-DD");
      let finalendDate = endDate + " " + "23:59";
      props.vendor_get_available_table_action(
        props.auth.user.VendorUser._id,
        finalStartDate,
        finalendDate,
        props.auth.user.accessToken
      );
    }
  }, [selectedPage]);

  /***************************
   * @DESC on Button Handler
   ***************************/
  const onButtonClick = (type) => (e) => {
    e.preventDefault();
    if (formik.values.seating_preference === type) {
      formik.setFieldValue("seating_preference", "");
    } else {
      formik.setFieldValue("seating_preference", type);
    }
    // console.log("Data ==>", type, formik.values.seating_preference);
  };

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="p-2">
              <div className="f24_700_HelveticaNeue pb-4">
                {dinerInfo ? "Edit" : "Add"} Diner
              </div>
              <div className="d-flex align-items-start">
                {dinerInfo?.service_type === "RESERVATION" ? null : (
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion d-flex flex-column align-items-center mr-5 ${
                      selectedPage === "SEATING" ? "active" : ""
                    }`}
                    onClick={onPageChange("SEATING")}
                  >
                    <Image
                      src={
                        // selectedPage === "SEATING"
                        //   ?
                        require("../../../../assets/images/seatingImages/newseaticon.svg")
                        // : require("../../../../assets/images/ActionImages/1/walk.svg")
                      }
                      style={
                        selectedPage === "SEATING"
                          ? {
                              border: "2px solid red",
                              borderRadius: "50%",
                              padding: "5px",
                            }
                          : {}
                      }
                      alt="View"
                      title="View"
                      fluid
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Walk-in/Wait
                    </span>
                  </Button>
                )}
                {dinerInfo?.service_type === "SEATING" ? null : (
                  <Button
                    variant="link"
                    className={`enAddOffersOPtion d-flex flex-column align-items-center ml-3 ${
                      selectedPage === "RESERVATION" ? "active" : ""
                    }`}
                    onClick={onPageChange("RESERVATION")}
                  >
                    <Image
                      src={
                        // selectedPage === "RESERVATION"
                        //   ?
                        require("../../../../assets/images/seatingImages/newreservationicon.svg")
                        // : require("../../../../assets/images/ActionImages/1/Reservations.svg")
                      }
                      style={
                        selectedPage === "RESERVATION"
                          ? {
                              border: "2px solid red",
                              borderRadius: "50%",
                              padding: "5px",
                            }
                          : {}
                      }
                      alt="View"
                      title="View"
                      fluid
                    />
                    <span className="active f12-400 d-block w-100 mb-2">
                      Reservations
                    </span>
                  </Button>
                )}
              </div>
              <hr />
              <FormDisplay
                formData={formik}
                handaleBlurFunc={handleNumber}
                editDinerData={dinerInfo}
                getCountriesData={getCountries}
                getCountryCallingCodeData={getCountryCallingCode}
                onClickSubmit={() => onClickSave()}
                highChairOnboarding={onBoardingHighChair}
                handicapOnboarding={onBoardingHandicap}
                tableNumberOnboarding={onBoardingTableNumber}
                roomNumberOnboarding={onBoardingRoomNumber}
                kidsOnboarding={onBoardingKids}
                autoPaxLimitOnboarding={autoAcceptPaxLimit}
                allSeatingAreasOnboarding={allSeatingArea}
                minStartDate={minDate}
                startDateChangeHandler={(e) => handleStartDateChange(e)}
                resvationSlotstime={reservationTimeSlots}
                getAvailableTableData={availableTableData}
                classes={classes}
                onButtonClickHandler={(title) => onButtonClick(title)}
                selectedType={selectedPage}
                minpeopleValue={minimumPeople}
                maxpeopleValue={maximumPeople}
                tableNumber={subcriptionTableNumber}
                auth={props.auth}
                highchairHandicappedDisable={highchairHandicappedDisable}
                onChangeAccessibility={() => onChangeAccessibility()}
              />
            </div>
          </div>
          {/* <div className="bottom-panel">
              <BottomNavigationMobile />
            </div> */}
        </Row>
      </Container>
    </React.Fragment>
  );
};

AddDinerReservationScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  change_table_status_table_management: PropTypes.func.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  allDinnerDetails: state.allDinerDetails.vendor_all_diner.data,
  dinerDetailsInfo: state.allDinerDetails.diner_Details,
  allSeatingAreas: state.category.seating_area,
  subscriptionDetails: state.onboarding.onboard_subscription_details,
  getReservationTimeSlots:
    state.allDinerDetails.get_vendor_reservation_timing_slots,
  getAvailableTableData: state.allDinerDetails.get_vendor_available_table_data,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  change_table_status_table_management,
  vendor_add_diner_reservation,
  get_diner_reservation,
  get_pending_diner,
  get_reservation_diner,
  vendor_get_timing_slots_reservation,
  vendor_get_available_table_action,
  vendor_dashboard_edit_action,
})(withRouter(AddDinerReservationScreen));

const FormDisplay = (props) => {
  /***************************************
   * Start Adult kids highchair handicap
   **************************************/
  const history = useHistory();
  const IncrementKidsItem = (e) => {
    e.preventDefault();
    props.formData.setFieldValue("kids", props.formData.values.kids + 1);
    props.formData.setFieldValue("error", "");
    // if (props.formData.values.adult === 1) {
    //   // if (props.formData.values.kids < 100) {
    //   //   props.formData.setFieldValue("kids", props.formData.values.kids + 1);
    //   //   props.formData.setFieldValue("adult", props.formData.values.adult + 1);
    //   // } else {
    //   //   props.formData.setFieldValue("kids", props.formData.values.kids + 1);
    //   // }
    //   props.formData.setFieldValue("kids", props.formData.values.kids + 1);
    //   props.formData.setFieldValue("error", "");
    // } else {
    //   props.formData.setFieldValue("error", "");
    //   props.formData.setFieldValue("kids", props.formData.values.kids + 1);
    // }
  };

  const IncrementAdultItem = (e) => {
    e.preventDefault();
    // let totalPeople = props.formData.values.adult + props.formData.values.kids;
    // if (totalPeople < props?.maxpeopleValue) {
    if (props.formData.values.adult < 100) {
      props.formData.setFieldValue("adult", props.formData.values.adult + 1);
      props.formData.setFieldValue("error", "");
    } else {
      return null;
    }
    // } else {
    //   Alert.error(
    //     `<h4>You can't add more than maximum number of waitlist people</h4>`,
    //     {
    //       position: "top-right",
    //       effect: "bouncyflip",
    //       beep: true,
    //       html: true,
    //       timeout: 3000,
    //       offset: 35,
    //     }
    //   );
    // }
  };

  const IncrementhandicapItem = (e) => {
    e.preventDefault();
    // let totalPeople = props.formData.values.adult + props.formData.values.kids;
    // let totalHighChairHandicapped =
    //   props.formData.values.highchair + props.formData.values.handicap;
    // if (totalPeople > totalHighChairHandicapped) {
    if (props.formData.values.handicap < 100) {
      props.formData.setFieldValue(
        "handicap",
        props.formData.values.handicap + 1
      );
      props.formData.setFieldValue("error", "");
    } else {
      return null;
    }
    // } else {
    //   Alert.error(`<h4>You can't add more than adult and kids people</h4>`, {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   });
    // }
  };

  const IncrementhighchairItem = (e) => {
    e.preventDefault();
    // let totalPeople = props.formData.values.adult + props.formData.values.kids;
    // let totalHighChairHandicapped =
    //   props.formData.values.highchair + props.formData.values.handicap;
    // if (totalPeople > totalHighChairHandicapped) {
    if (props.formData.values.highchair < 100) {
      props.formData.setFieldValue(
        "highchair",
        props.formData.values.highchair + 1
      );
      props.formData.setFieldValue("error", "");
    } else {
      return null;
    }
    // } else {
    //   Alert.error(`<h4>You can't add more than adult and kids people</h4>`, {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   });
    // }
  };

  const DecreaseKidsItem = (e) => {
    e.preventDefault();
    if (props.formData.values.kids > 0) {
      props.formData.setFieldValue("kids", props.formData.values.kids - 1);
      props.formData.setFieldValue("error", "");
    } else {
      return null;
    }
  };

  const DecreaseAdultItem = (e) => {
    e.preventDefault();
    if (props.formData.values.adult > 1) {
      props.formData.setFieldValue("adult", props.formData.values.adult - 1);
      props.formData.setFieldValue("error", "");
    } else if (props.formData.values.adult <= 1) {
      Alert.error(`<h4>Atleast one adult is required</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      return null;
    }
  };

  const DecreaseHandicapItem = (e) => {
    e.preventDefault();
    if (props.formData.values.handicap > 0) {
      props.formData.setFieldValue(
        "handicap",
        props.formData.values.handicap - 1
      );
      props.formData.setFieldValue("error", "");
    } else {
      return null;
    }
  };

  const DecreaseHighchairItem = (e) => {
    e.preventDefault();
    if (props.formData.values.highchair > 0) {
      props.formData.setFieldValue(
        "highchair",
        props.formData.values.highchair - 1
      );
      props.formData.setFieldValue("error", "");
    } else {
      return null;
    }
  };
  /***************************************
   * End Adult kids highchair handicap
   **************************************/

  const totalAdultKids =
    props.formData.values.kids + props.formData.values.adult;

  return (
    <React.Fragment>
      <Form className="py-4">
        <Row>
          <Col md={12} lg={10} xl={8}>
            <Row>
              <Col md={6}>
                <Row>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Form.Group
                      // className="reusableInputComponent-main mb-0"
                      controlId={"code"}
                    >
                      <div className="input-phone-country-code-reusable w-100">
                        <select
                          id="code"
                          name="code"
                          value={props.formData.values.code}
                          onChange={props.formData.handleChange}
                          className="w-100"
                        >
                          <option value={props.formData.values.code}>
                            {props.formData.values.code}
                          </option>
                          {props.getCountriesData().map((country) => (
                            <option
                              key={country}
                              value={
                                "+" + props.getCountryCallingCodeData(country)
                              }
                            >
                              {en[country]} (+
                              {props.getCountryCallingCodeData(country)})
                            </option>
                          ))}
                        </select>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={8}>
                    <Form.Group>
                      <TextField
                        id="mobile_number"
                        label="Phone Number"
                        type="number"
                        variant="outlined"
                        className={`w-100 ${
                          props.formData.errors.mobile_number &&
                          props.formData.touched.mobile_number
                            ? "enError"
                            : ""
                        }`}
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 10);
                        }}
                        name="mobile_number"
                        onChange={props.formData.handleChange}
                        value={
                          props.formData.values.mobile_number ||
                          props.formData.initialValues.mobile_number
                        }
                        onBlur={
                          (props.formData.handleBlur, props.handaleBlurFunc)
                        }
                      />
                      {props.formData.errors.mobile_number &&
                      props.formData.touched.mobile_number ? (
                        <div className="pho_14_regular text-danger">
                          {props.formData.errors.mobile_number}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    id="dinerName"
                    label="Name"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      props.formData.errors.dinerName &&
                      props.formData.touched.dinerName
                        ? "enError"
                        : ""
                    }`}
                    inputProps={{
                      maxLength: 64,
                    }}
                    name="dinerName"
                    onChange={props.formData.handleChange}
                    value={
                      props.formData.values.dinerName ||
                      props.formData.initialValues.dinerName
                    }
                    onBlur={props.formData.handleBlur}
                  />
                  {props.formData.errors.dinerName &&
                  props.formData.touched.dinerName ? (
                    <div className="pho_14_regular text-danger">
                      {props.formData.errors.dinerName}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              <Col md={12} lg={8}>
                <div className="f16-500">Party Size</div>
                <div className="f11-500 opacity5 pb-4">
                  Kids Category below 6 years
                </div>
                <div className="d-flex enPartySize">
                  {props.kidsOnboarding ? (
                    <div className="d-flex pr-3 pb-3">
                      <div className="enKidsIcon mr-2">
                        <Image
                          src={require("../../../../assets/images/ActionImages/children.png")}
                          alt="View"
                          title="View"
                          width="9px"
                        />
                      </div>
                      <div className="pl-md-2 enPartyPersonEdit">
                        <div className="f14-500 pb-2">Kids</div>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="link"
                            className="p-0"
                            onClick={DecreaseKidsItem}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/minus.svg")}
                              alt="Remove"
                              title="Remove"
                              fluid
                            />
                          </Button>
                          <input
                            placeholder="00"
                            className="enInputValueOnly f12-700"
                            value={props.formData.values.kids}
                            name="kids"
                            id="kids"
                          />
                          <Button
                            variant="link"
                            className="p-0"
                            onClick={IncrementKidsItem}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/plus.svg")}
                              alt="Add"
                              title="Add"
                              fluid
                            />
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <>
                    <div className="d-flex border-left pl-3 pb-3">
                      <div className="enKidsIcon mr-2">
                        <Image
                          src={require("../../../../assets/images/ActionImages/employees.png")}
                          alt="View"
                          title="View"
                          width="9px"
                        />
                      </div>
                      <div className="pl-md-2 enPartyPersonEdit">
                        <div className="f14-500 pb-2">Adult</div>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="link"
                            className="p-0"
                            onClick={DecreaseAdultItem}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/minus.svg")}
                              alt="Remove"
                              title="Remove"
                              fluid
                            />
                          </Button>
                          <input
                            placeholder="00"
                            className="enInputValueOnly f12-700"
                            value={props.formData.values.adult}
                            name="adult"
                            id="adult"
                          />
                          <Button
                            variant="link"
                            className="p-0"
                            onClick={IncrementAdultItem}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/plus.svg")}
                              alt="Add"
                              title="Add"
                              fluid
                            />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
                <div className="col-4 offset-5 mt-3 pho_14_regular text-danger">
                  {props.formData.values.error}
                </div>
                {props.handicapOnboarding === true ||
                props.highChairOnboarding === true ? (
                  <>
                    <hr />
                    <div className="d-flex flex-wrap align-items-center pb-4">
                      <div className="f16-500 mr-2">
                        Need Handicap or Highchair Accessibility?
                      </div>
                      <div className="d-flex align-items-center py-4 pl-md-4">
                        <div className="f16-500 mr-2">No</div>
                        <Switch
                          onChange={props.onChangeAccessibility}
                          // disabled={true}
                          checked={
                            props.highchairHandicappedDisable
                            // props.handicapOnboarding === false &&
                            // props.highChairOnboarding === false
                            //   ? false
                            //   : true
                          }
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={disabled === true ? true : false}
                        />
                        <div className="f16-500 ml-2">Yes</div>
                      </div>
                    </div>
                  </>
                ) : null}

                {/* props.handicapOnboarding === true ||
                props.highChairOnboarding === true */}
                {props.highchairHandicappedDisable ? (
                  <div className="d-flex enPartySize pb-4">
                    {props.handicapOnboarding === true ? (
                      <div className="d-flex pr-3 pb-3">
                        <div className="enKidsIcon mr-2">
                          <Image
                            src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                            alt="View"
                            title="View"
                            className="custom"
                          />
                        </div>
                        <div className="pl-md-2 enPartyPersonEdit">
                          <div className="f14-500 pb-2">Handicap</div>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={DecreaseHandicapItem}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/minus.svg")}
                                alt="Remove"
                                title="Remove"
                                fluid
                              />
                            </Button>
                            <input
                              placeholder="00"
                              className="enInputValueOnly f12-700"
                              value={props.formData.values.handicap}
                              name="handicap"
                              id="handicap"
                            />
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={IncrementhandicapItem}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/plus.svg")}
                                alt="Add"
                                title="Add"
                                fluid
                              />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {props.highChairOnboarding === true ? (
                      <div className="d-flex border-left pl-3 pb-3">
                        <div className="enKidsIcon mr-2">
                          <Image
                            src={require("../../../../assets/images/ActionImages/highchair.svg")}
                            alt="View"
                            title="View"
                            className="custom"
                          />
                        </div>
                        <div className="pl-md-2 enPartyPersonEdit">
                          <div className="f14-500 pb-2">Highchair</div>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={DecreaseHighchairItem}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/minus.svg")}
                                alt="Remove"
                                title="Remove"
                                fluid
                              />
                            </Button>
                            <input
                              placeholder="00"
                              className="enInputValueOnly f12-700"
                              value={props.formData.values.highchair}
                              name="highchair"
                              id="highchair"
                            />
                            <Button
                              variant="link"
                              className="p-0"
                              onClick={IncrementhighchairItem}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/plus.svg")}
                                alt="Add"
                                title="Add"
                                fluid
                              />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {props.selectedType === "SEATING" ? (
                  ""
                ) : props.selectedType === "RESERVATION" ? (
                  <hr />
                ) : (
                  ""
                )}
                {props.selectedType === "SEATING" ? (
                  ""
                ) : props.selectedType === "RESERVATION" ? (
                  <Form.Row>
                    <div className="col-6">
                      <TextField
                        id="start_date"
                        label="Start Date"
                        variant="outlined"
                        InputProps={{
                          inputProps: { min: props.minStartDate },
                        }}
                        type="date"
                        defaultValue={props.minStartDate}
                        className={`w-100 ${
                          props.formData.errors.start_date &&
                          props.formData.touched.start_date
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="start_date"
                        onChange={props.startDateChangeHandler}
                        value={props.formData.values.start_date}
                        onBlur={props.formData.handleBlur}
                      />
                      {props.formData.errors.start_date &&
                      props.formData.touched.start_date ? (
                        <div className="pho_14_regular text-danger">
                          {props.formData.errors.start_date}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-6">
                      <FormControl
                        variant="outlined"
                        className={props.classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-time">
                          Reservation Time
                        </InputLabel>
                        <Select
                          value={props.formData.values.time}
                          onChange={props.formData.handleChange}
                          label="Reservation Time"
                          inputProps={{
                            name: "time",
                            id: "outlined-time",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem
                            value=""
                            disabled
                            selected={
                              !props?.resvationSlotstime?.includes(
                                moment(
                                  new Date(
                                    props?.editDinerData?.reservationTime
                                  )
                                ).format("H:mm A")
                              )
                            }
                          >
                            Select Restaurant Time
                          </MenuItem>

                          {props?.resvationSlotstime?.includes(
                            moment(
                              new Date(props?.editDinerData?.reservationTime)
                            ).format("H:mm A")
                          ) ? null : (
                            <MenuItem
                              value={moment(
                                new Date(props?.editDinerData?.reservationTime)
                              ).format("H:mm A")}
                              disabled
                            >
                              {moment(
                                new Date(props?.editDinerData?.reservationTime)
                              ).format("H:mm A")}
                            </MenuItem>
                          )}
                          {props.resvationSlotstime &&
                            props.resvationSlotstime.map((time, index) => (
                              <MenuItem key={index} value={time}>
                                {time}
                              </MenuItem>
                            ))}
                        </Select>
                        {props.formData.errors.time &&
                        props.formData.touched.time ? (
                          <div className="pho_14_regular text-danger">
                            {props.formData.errors.time}
                          </div>
                        ) : null}
                      </FormControl>
                    </div>
                  </Form.Row>
                ) : (
                  ""
                )}
                <hr />
                <Form.Row>
                  {props.roomNumberOnboarding === true ? (
                    <Col xs={6} md={6}>
                      <Form.Group>
                        <TextField
                          id="room_number"
                          label="Room No."
                          type="number"
                          variant="outlined"
                          className={`w-100 ${
                            props.formData.errors.room_number &&
                            props.formData.touched.room_number
                              ? "enError"
                              : ""
                          }`}
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                          name="room_number"
                          onChange={props.formData.handleChange}
                          value={props.formData.values.room_number}
                          onBlur={props.formData.handleBlur}
                        />
                        {props.formData.errors.room_number &&
                        props.formData.touched.room_number ? (
                          <div className="pho_14_regular text-danger">
                            {props.formData.errors.room_number}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  ) : null}
                  {totalAdultKids <= props.autoPaxLimitOnboarding ? (
                    <Col xs={6} md={6}>
                      {/* {props.auth.loader ? (
                        <Loader
                          type="ThreeDots"
                          color="#00BFFF"
                          height={39}
                          width={39}
                        />
                      ) : null} */}
                      <FormControl
                        variant="outlined"
                        className={props.classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-time">
                          Table No.
                        </InputLabel>
                        <Select
                          onChange={props.formData.handleChange}
                          value={props.formData.values.table_number}
                          label="Table No."
                          inputProps={{
                            name: "table_number",
                            id: "outlined-time",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value="" disabled selected>
                            Select Table Number
                          </MenuItem>
                          {props.getAvailableTableData &&
                            props.getAvailableTableData?.map((data, index) => {
                              return data.status === "AVAILABLE" ? (
                                <MenuItem
                                  key={index}
                                  value={data.table_number}
                                  name={data.table_number}
                                >
                                  {data.table_number}
                                </MenuItem>
                              ) : null;
                            })}
                          {props?.editDinerData?.table_number !== undefined &&
                          props?.editDinerData?.table_number !== null ? (
                            props?.editDinerData?.table_number
                              .split(",")
                              .map((data) => {
                                return (
                                  <MenuItem key={data} value={data} name={data}>
                                    {data}
                                  </MenuItem>
                                );
                              })
                          ) : (
                            <MenuItem value="select">Select</MenuItem>
                          )}
                          {/* {props?.editDinerData?.table_number
                            .split(",")
                            .map((data) => {
                              return (
                                <MenuItem key={data} value={data} name={data}>
                                  {data}
                                </MenuItem>
                              );
                            })} */}
                        </Select>
                        {props.formData.errors.table_number &&
                        props.formData.touched.table_number ? (
                          <div className="pho_14_regular text-danger">
                            {props.formData.errors.table_number}
                          </div>
                        ) : null}
                      </FormControl>
                      {/* <Form.Group>
                        <TextField
                          id="table_number"
                          label="Table No.1"
                          type="number"
                          variant="outlined"
                          className={`w-100 ${
                            props.formData.errors.table_number &&
                            props.formData.touched.table_number
                              ? "enError"
                              : ""
                          }`}
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                          name="table_number"
                          onChange={props.formData.handleChange}
                          value={props.formData.values.table_number}
                          onBlur={props.formData.handleBlur}
                        />
                        
                        
                        {props.formData.errors.table_number &&
                        props.formData.touched.table_number ? (
                          <div className="pho_14_regular text-danger">
                            {props.formData.errors.table_number}
                          </div>
                        ) : null}
                      </Form.Group> */}
                    </Col>
                  ) : null}
                </Form.Row>
                <Row>
                  <Col md={12}>
                    <div className="f16-500 pb-1 pt-3">Seating Preference</div>
                    <div className="f12-400 pb-3">
                      Seating is a subject to availability. Your Preference will
                      be considered.
                    </div>
                  </Col>
                </Row>
                <Form.Row>
                  {props.allSeatingAreasOnboarding &&
                    props.allSeatingAreasOnboarding.map((item, index) => (
                      <div className="col-6 col-md-4" key={index}>
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection={
                            props.formData.values.seating_preference ===
                            item.title
                              ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                              : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }
                          src={item.icon}
                          title={item.title}
                          onClick={props.onButtonClickHandler(item.title)}
                        />
                      </div>
                    ))}
                </Form.Row>
              </Col>
              <Col md={12}>
                <div className="f16-500 pt-3 pb-2">Special Occasion</div>
                <Form.Group>
                  <NewInputText
                    controlClass="occasion"
                    labelText="E.g. Wedding Anniversary"
                    type="text"
                    variant="outlined"
                    multiline
                    rows={4}
                    className={`w-100 ${
                      props.formData.errors.occasion &&
                      props.formData.touched.occasion
                        ? "enError"
                        : ""
                    }`}
                    inputProps={{
                      maxLength: 512,
                    }}
                    name="occasion"
                    onChange={props.formData.handleChange}
                    value={props.formData.values.occasion}
                    onBlur={props.formData.handleBlur}
                  />
                  {props.formData.errors.occasion &&
                  props.formData.touched.occasion ? (
                    <div className="pho_14_regular text-danger">
                      {props.formData.errors.occasion}
                    </div>
                  ) : null}
                </Form.Group>
                <Media query="(min-width: 992px)">
                  <div className="d-flex align-items-center pt-4">
                    <Button
                      variant="outline-secondary"
                      className="btn150px btn-lg mr-4 px-5"
                      onClick={() => history.push("/seatingdashboard")}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn150px btn-lg px-5 mr-3"
                      onClick={props.onClickSubmit}
                      type="button"
                      title={props.editDinerData ? "Update" : "Save"}
                      disabled={props.auth.loader ? true : false}
                    >
                      {props.editDinerData ? "Update" : "Save"}
                    </Button>
                    {props.auth.loader ? (
                      <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={30}
                        width={30}
                      />
                    ) : null}
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <div className="d-flex justify-content-center py-2 border-top fixed-bottom bg-white">
                    <Button
                      variant="outline-secondary"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      onClick={() => history.push("/seatingdashboard")}
                    >
                      Cancel
                    </Button>
                    <div className="ml-2 mr-3">
                      <Button
                        variant="danger"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        onClick={props.onClickSubmit}
                        type="button"
                        title={props.editDinerData ? "Update" : "Save"}
                        disabled={props.auth.loader ? true : false}
                      >
                        {props.editDinerData ? "Update" : "Save"}
                      </Button>
                    </div>
                    {props.auth.loader ? (
                      <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={30}
                        width={30}
                      />
                    ) : null}
                  </div>
                </Media>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};
